export enum CustomerAdditionalInfoType {
  Addresses = "addresses",
  ContactAddresses = "contactAddresses",
  Partners = "partners",
}
